export const jackal_jacket = {
  msrp: 59.99,
  variants: [
    ['SHORT SLEEVE', 'LONG SLEEVE'],
    ['HOODIE', 'QUARTER ZIP'],
  ],
  infoLink: 'https://www.teamtriton.com/jackal-jacket.html',
  items: [
    {
      number: 'JJ99',
      hasModel: false,
    },
    {
      number: 'JJ100',
      hasModel: false,
    },
    {
      number: 'JJ101',
      hasModel: false,
    },
    {
      number: 'JJ102',
      hasModel: false,
    },
    {
      number: 'JJ103',
      hasModel: false,
    },
    {
      number: 'JJ104',
      hasModel: false,
    },
    {
      number: 'JJ105',
      hasModel: false,
    },
    {
      number: 'JJ106',
      hasModel: false,
    },
    {
      number: 'JJ107',
      hasModel: false,
    },
    {
      number: 'JJ108',
      hasModel: false,
    },
    {
      number: 'JJ109',
      hasModel: false,
    },
    {
      number: 'JJ110',
      hasModel: false,
    },
  ],
};
